import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Подключить подписку ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Нажимая кнопку \"Подключить подписку\" Вы будете перенаправлены на страницу оплаты ")

import { Component, computed, PropType } from "vue";

import { usePermissions } from "@/use/usePermissions";
import { TPermission } from "@/types/permission";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import { HeroIcons } from "@/plugins/ui/components/icon";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
import { useStore } from "@/use/useStore";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";

interface IModule {
  icon: HeroIcons;
  title: string;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableModules',
  props: {
  type: {
    type: String as PropType<"subscription" | "unsupported">,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { currentUser } = useStore();
const { permissions } = usePermissions();

const modules: Record<TPermission, IModule> = {
  menu_voting: {
    icon: "LockOpen",
    title: "Оценка меню",
    description: "Возможность ежедневной оценки удовлетворённости питанием",
  },

  acs: {
    icon: "LockOpen",
    title: "События СКУД",
    description: "Информация о событиях прохода",
  },

  ban: {
    icon: "Ban",
    title: "Запреты и баны",
    description:
      "Установка запретов на приобретение продукции по типу и позициям",
  },

  bot: {
    icon: "LockOpen",
    title: "Уведомления в мессенджер",
    description: "Уведомления в реальном времени и чат-бот",
  },

  entrant: {
    icon: "User",
    title: "Личный кабинет ребенка",
    description: "Доступ к личному кабинету обучающегося",
  },

  identifiers: {
    icon: "CreditCard",
    title: "Управление идентификаторами",
    description: "",
  },

  menu: {
    icon: "Clipboard",
    title: "Школьное меню",
    description: "Просмотр меню",
  },

  pay: {
    icon: "LockOpen",
    title: "Пополнение счета онлайн",
    description: "Возможность пополнять счет через СБОЛ и СБП",
  },

  qr: {
    icon: "Qrcode",
    title: "Проход по QR-коду",
    description:
      "Простая замена идентификатора ребенка на функциональный QR-код для оплаты питания в столовой и прохода в учреждение",
  },

  request: {
    icon: "ShoppingBag",
    title: "Заказ еды",
    description: "Заказ еды в обедомате на следующий день",
  },

  score_limit: {
    icon: "ArrowsExpand",
    title: "Установка лимита",
    description: "Лимит на количество средств, которые можно потратить за день",
  },

  score_operation: {
    icon: "ChartSquareBar",
    title: "История операций",
    description: "История операций питания в столовой",
  },

  score_sub: {
    icon: "LockOpen",
    title: "Баланс лицевого счета",
    description: "Просмотр баланса лицевого счета",
  },

  subscription: {
    icon: "LockOpen",
    title: "События СКУД",
    description: "Информация о событиях прохода",
  },

  news: {
    icon: "Newspaper",
    title: "Объявления и голосования",
    description:
      "Будьте в курсе последних событий в школе, приложении, и учавствуйте в опросах!",
  },
};

const availableModules = computed(() => {
  const aboba = permissions.value
    .filter((p) => !p.available && p.type === props.type)
    .map((p) => p.name);

  return permissions.value
    .filter((p) => !p.available && p.type === props.type)
    .map((p) => p.name);
});

const titles: Record<"subscription" | "unsupported", string> = {
  subscription: "Модули в расширенной подписке",
  unsupported: "Модули недоступные в вашей школе",
};

const descriptions: Record<"subscription" | "unsupported", string> = {
  subscription:
    "После подключения расширенной подписки на личный кабинет, Вам будут доступные следующие модули:",
  unsupported: "К сожалению, эти модули пока не доступны в Вашей школе.",
};

const subscribeUrl = computed(
  () =>
    `https://z.edu28.ru/pay?score_id=${currentUser.value?.score_id}&service_id=1&target=0`,
);

return (_ctx: any,_cache: any) => {
  return (_unref(availableModules).length)
    ? (_openBlock(), _createBlock(UiGroup, { key: 0 }, {
        header: _withCtx(() => [
          _createVNode(UiHeader, {
            title: titles[__props.type],
            description: descriptions[__props.type],
            multiline: ""
          }, null, 8, ["title", "description"])
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, _createSlots({
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableModules), (m) => {
                return (_openBlock(), _createBlock(UiCell, {
                  key: m,
                  title: modules[m]?.title || 'Без названия',
                  description: modules[m]?.description || 'Описание отсутствует',
                  multiline: ""
                }, null, 8, ["title", "description"]))
              }), 128))
            ]),
            _: 2
          }, [
            (__props.type === 'subscription')
              ? {
                  name: "footer",
                  fn: _withCtx(() => [
                    _createElementVNode("a", {
                      href: _unref(subscribeUrl),
                      target: "_blank",
                      rel: "noreferrer"
                    }, [
                      _createVNode(UiBtn, { block: "" }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_1),
                    _createVNode(UiCaption, { style: {"margin-top":"8px","color":"#818c99"} }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})